import { z } from 'zod'

// the resolved per-account bot visibility toggles.
export const botVisibilityResponseSchema = z.object({
  tradingBotVisible: z.boolean(),
  dayTradeBotVisible: z.boolean(),
})

export type BotVisibilityResponseDto = z.infer<typeof botVisibilityResponseSchema>

// partial update — at least one toggle must be provided. an omitted field is left untouched.
export const updateBotVisibilitySchema = z
  .object({
    tradingBotVisible: z.boolean().optional(),
    dayTradeBotVisible: z.boolean().optional(),
  })
  .refine((v) => v.tradingBotVisible !== undefined || v.dayTradeBotVisible !== undefined, {
    message: 'At least one visibility toggle must be provided',
  })

export type UpdateBotVisibilityDto = z.infer<typeof updateBotVisibilitySchema>
